module.exports = __webpack_public_path__ + "static/img/1041_small.fec3a06.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1041_small.png
// module id = 9O3l
// module chunks = 1